module.exports = __webpack_public_path__ + "assets/img/sdgs_logo.31fafe78.png";